module.exports = __webpack_public_path__ + "img/404.ca1c901f.png";